import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as i, createElementBlock as n, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCalendarDays",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, h = ["aria-label", "data-qa", "aria-hidden"];
function m(e, r, d, u, f, a) {
  return i(), n("svg", {
    "aria-label": d.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--calendar-days"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Calendar Days",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...r[0] || (r[0] = [
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.5 7a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Zm2 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm2 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5Zm-4 2a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Zm2 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm2 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5Z",
      fill: "currentColor"
    }, null, -1),
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1 3a1.5 1.5 0 0 1 1.5-1.5h1V1a.5.5 0 0 1 1 0v.5h3V1a.5.5 0 0 1 1 0v.5h1A1.5 1.5 0 0 1 11 3v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 1 10V3Zm1 0a.5.5 0 0 1 .5-.5h1V3a.5.5 0 0 0 1 0v-.5h3V3a.5.5 0 0 0 1 0v-.5h1a.5.5 0 0 1 .5.5v1.5H2V3Zm.5 7.5A.5.5 0 0 1 2 10V5.5h8V10a.5.5 0 0 1-.5.5h-7Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, h);
}
const Z = /* @__PURE__ */ s(c, [["render", m]]);
export {
  Z as default
};
//# sourceMappingURL=calendar-days.js.map
